import { inject } from '@angular/core';
import { CanActivateFn, CanMatchFn, Router } from '@angular/router';
import { AuthenticationService } from '@app/core/authentication/services/authentication.service';
import { AppRoute } from '@app/app-routes.enum';
import { map, take } from 'rxjs';

export const unauthenticatedGuard: CanActivateFn | CanMatchFn = () => {
  const authService: AuthenticationService = inject(AuthenticationService);
  const router: Router = inject(Router);

  return authService.isUserAuthenticated().pipe(
    take(1),
    map(isAuthenticated => (isAuthenticated ? router.createUrlTree([AppRoute.Base]) : true))
  );
};
